import isEqual from 'lodash/isEqual';
import sortBy from 'lodash/sortBy';

export const AreArrayContentSame = (array1, array2) => {
  return isEqual(sortBy(array1), sortBy(array2));
};
